import React from 'react';

import MIcon from '../MIcon/MIcon';
import MSelectList from '../MSelectList/MSelectList';

import classes from './MSelect.module.scss';
import { condClass } from 'app/utils/general';
import { IDropdownListOption } from '../MSelectList/MSelectList.model';

interface Props<ValueType extends string | number> {
  className?: string;
  listRef: React.RefObject<HTMLUListElement>;
  showList: boolean;
  label: React.ReactNode | null;
  selected: ValueType | null;
  placeholder?: string;
  options: IDropdownListOption<ValueType>[];
  onButtonClick: () => void;
  onOptionClick: (value: ValueType, index: number) => void;
}

const MSelectView = <ValueType extends string | number>(props: React.PropsWithChildren<Props<ValueType>>): JSX.Element => {
  return (
    <div className={condClass({ [classes['container']]: true, [String(props.className)]: !!props.className })}>
      <button type="button" onClick={props.onButtonClick} className={classes['btnContent']}>
        {<span className={classes['text']}></span> ? <span className={classes['text']}>{props.label}</span> : props.placeholder || ''}
        <MIcon className={classes['chevron']} name="cisChevronBottomAlt"></MIcon>
      </button>
      {props.showList ? (
        <MSelectList
          listRef={props.listRef}
          className={classes['list']}
          selected={props.selected}
          onOptionClick={props.onOptionClick}
          options={props.options}
        ></MSelectList>
      ) : null}
    </div>
  );
};

MSelectView.displayName = 'MSelectView';
MSelectView.defaultProps = {};

export default MSelectView;
